import React, {useCallback, useRef, useEffect, useMemo} from 'react'
import StandardModalContent from 'GeneralUI/StandardModalContent/StandardModalContent.jsx'
import { push, encodeItemURIComponents } from 'Helper/routeHelpers'
import { getCurrentScreenType } from 'Helper/screenTypeHelpers'
import { useLocation } from 'react-router-dom'
import { xtractAPI } from 'actions/apiActions'
import { useDispatch } from 'react-redux'

const DeleteWorkflowModal = ({
  startSpinner,
  endSpinnerWithError,
  endSpinnerWithSuccess,
  currentWorkflowPath,
  workflows,
  workflowId,
  workflowName = '',
  closeSelf = () => null,
  closeParent = () => null
}) => {
  const dispatch = useDispatch()

  const { pathname } = useLocation()

  const currentScreenType = useMemo(getCurrentScreenType,[])

  const saveWorkflowsToApi = useCallback((workflows, callback = () => null) => {
    const workflowData = JSON.stringify(workflows.map(encodeItemURIComponents))

    const callbacks = {
      200: response => {
        endSpinnerWithSuccess()
        callback()
      },
      400: (response, action) => endSpinnerWithError({ action, response, errors: response.data.errors }),
      error: (response, action) => endSpinnerWithError({ response, action })
    }

    startSpinner()
    if(workflowId) {
      dispatch(xtractAPI(`config/${workflowId}`, 'update', { value: workflowData }, callbacks))
    } else {
      dispatch(xtractAPI(`config`, 'create', { value: workflowData }, callbacks))
    }
  }, [workflowId, endSpinnerWithError, endSpinnerWithSuccess, startSpinner, encodeItemURIComponents])

  const deleteWorkflow = useCallback(() => {
    let allWorkflows = _.cloneDeep(workflows)
    allWorkflows = allWorkflows.filter(workflow => !(workflow.path === currentWorkflowPath && workflow.screenType === currentScreenType))
    
    const split = pathname.split('/workflow')
    saveWorkflowsToApi(allWorkflows, () => {push(split[0]); closeParent()})
  }, [workflows, currentWorkflowPath, currentScreenType, pathname, saveWorkflowsToApi, closeParent])

  const deleteWorkflowRef = useRef(() => null)
  useEffect(() => {
    deleteWorkflowRef.current = deleteWorkflow
  }, [deleteWorkflow])
  
  return (
  <StandardModalContent
    messageContent={
    <div style={{ margin: '25px' }}>
        Are you sure you want to delete <b>{workflowName} </b>workflow?
    </div>
    }
    cancelText={'No'}
    cancelHandler={() => false}
    okText={'Yes'}
    okHandler={() => deleteWorkflowRef.current()}
    closeSelf={closeSelf}
  />
  )
}

export default DeleteWorkflowModal